import ChevronLeftIcon from "./ChevronLeftIcon";
export default ChevronLeftIcon;
